export default {
    /**
     * @static
     * @type {number}
     * @default 1664
     */
    STAGE_WIDTH: 1792,

    /**
     * @static
     * @type {number}
     * @default 768
     */
    STAGE_HEIGHT: 768,

    /**
     * @static
     * @type {Object}
     */
    config: {},

    /**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
    renderer: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    stage: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    transitions: null,

    /**
     * @static
     * @type {SaveData}
     */
    saveData: null
}